import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import './Select.custom.scss';

function Select({ label, labelClassName, title, hidden, value, options, onSelect, className }) {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  // eslint-disable-next-line no-shadow
  const handleSelect = (value) => {
    onSelect(value);
    setOpen(false);
  };

  return (
    <div className={cn('profile-settings-select', className)}>
      <div className={cn('profile-settings-select_label', labelClassName)}>{label}</div>
      <div className={cn('els-select-wrapper small', open && 'open', hidden && 'hidden')}>
        <div className="els-select">
          {/* eslint-disable-next-line max-len */}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a className="els-select-placeholder" title={title || label} onClick={toggleOpen}>
            {value}
            <span className="els-select-placeholder-icon ss-navigatedown no-border" />
          </a>
          <ul className="els-select-options">
            {options.map((option) => (
              <li key={`option-${option.value}`}>
                {/* eslint-disable-next-line max-len */}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
                <a className={cn(value === option.value && 'selected')} onClick={() => handleSelect(option.value)}>
                  <span className="els-select-options-wrapper">{option.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

Select.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelClassName: PropTypes.string,
  title: PropTypes.string,
  hidden: PropTypes.bool,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  onSelect: PropTypes.func,
  className: PropTypes.string,
};

Select.defaultProps = {
  options: [],
  onSelect: noop,
};

export default Select;
